export const normalizeLink = (link: string): string => (/.*:\/\//.test(link) ? link : `https://${link}`);
